/**
 * RequestDetailsModal Component (Sponsor View)
 *
 * Modal for viewing full details of a sponsor's advisory request
 */

import React from 'react';
import Modal from 'components/Modal';
import Text from 'components/Text';
import { LeadRequest } from 'types/leadRequestsTypes';
import StatusBadge from '../../LeadRequestOrchestration/components/StatusBadge';
import * as S from '../../LeadRequestOrchestration/components/styles';
import { format } from 'date-fns';

interface RequestDetailsModalProps {
  request: LeadRequest | null;
  isOpen: boolean;
  onClose: () => void;
}

const RequestDetailsModal: React.FC<RequestDetailsModalProps> = ({
  request,
  isOpen,
  onClose,
}) => {
  if (!request) return null;

  const renderFormResponses = () => {
    if (!request.form_responses) {
      return <Text color="textSecondary">Nenhum dado do formulário disponível</Text>;
    }

    if (typeof request.form_responses === 'object' && !Array.isArray(request.form_responses)) {
      return (
        <S.FormDataDisplay>
          {Object.entries(request.form_responses).map(([key, value]) => (
            <S.FormDataRow key={key}>
              <S.FormDataLabel>{key}</S.FormDataLabel>
              <S.FormDataValue>{String(value)}</S.FormDataValue>
            </S.FormDataRow>
          ))}
        </S.FormDataDisplay>
      );
    }

    return <Text color="textSecondary">Dados do formulário: {JSON.stringify(request.form_responses)}</Text>;
  };

  return (
    <Modal
      closeModal={onClose}
      title="Detalhes da solicitação"
      onSecondaryClick={onClose}
      secondaryTextButton="Fechar"
    >
      <S.ModalContent>
        {/* Request Info */}
        <S.ModalSection>
          <S.ModalSectionTitle>Informações da solicitação</S.ModalSectionTitle>
          <S.FormDataDisplay>
            <S.FormDataRow>
              <S.FormDataLabel>ID da solicitação</S.FormDataLabel>
              <S.FormDataValue>{request.id}</S.FormDataValue>
            </S.FormDataRow>
            <S.FormDataRow>
              <S.FormDataLabel>Status:</S.FormDataLabel>
              <S.FormDataValue>
                <StatusBadge status={request.status} />
              </S.FormDataValue>
            </S.FormDataRow>
            <S.FormDataRow>
              <S.FormDataLabel>Criado em:</S.FormDataLabel>
              <S.FormDataValue>
                {format(new Date(request.created_at), 'dd/MM/yyyy HH:mm')}
              </S.FormDataValue>
            </S.FormDataRow>
            <S.FormDataRow>
              <S.FormDataLabel>Atualizado em:</S.FormDataLabel>
              <S.FormDataValue>
                {format(new Date(request.updated_at), 'dd/MM/yyyy HH:mm')}
              </S.FormDataValue>
            </S.FormDataRow>
          </S.FormDataDisplay>
        </S.ModalSection>

        {/* Form Responses */}
        <S.ModalSection>
          <S.ModalSectionTitle>Respostas do formulário</S.ModalSectionTitle>
          {renderFormResponses()}
        </S.ModalSection>
      </S.ModalContent>
    </Modal>
  );
};

export default RequestDetailsModal;
